<template>
  <CCard>
    <CCardHeader>
      <CRow>
      </CRow>
      <!--        </div>-->

      <!-- Right aligned nav items -->
      <!--      </CCollapse>-->
    </CCardHeader>
    <CCardBody>

      <BTabs>
        <BTab v-if="has_permission('AccountingGroupSetting') && get_access('accounting_groups')" :title="$t('sidebars.accountingGroup')">

          <CCardBody>
            <AccountingGroupsTree/>
          </CCardBody>

        </BTab>
        <BTab v-if="has_permission('AccountingGroupSetting')" :title="$t('ChartAccountSetting')">
          <AccountingGroupsLists2/>
        </BTab>

<!--        <CTab   v-if="has_permission('Cashiers') " :title="$t('cashBalance')">-->
<!--          <Cashiers/>-->
<!--        </CTab>-->
<!--        <CTab  v-if="has_permission('Banks')" :title="$t('sidebars.banks')">-->
<!--          <Banks/>-->
<!--        </CTab>-->

        <BTab  v-if="has_permission('DefaultAccounts') && get_access('default_accounts')" :title="$t('defaultAccount')">
          <NumberingSettings3/>
        </BTab>

        <BTab v-if="get_access('default_accounts')" title="Detail Accounting Docs">
          <ReportAccountingDocDetails/>
        </BTab>

      </BTabs>

    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import AccountingGroupsLists2 from "./AccountingGroupsLists2";
import AccountingGroupsTree from "./AccountingGroupsTree";
import Vat from "../settings/Vat";
import Cashiers from "./Cashiers";
import Banks from "./Banks";
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import BTabs from "../../tabs/BTabs";
import SaleMethods from "./SaleMethods";
import NumberingSettings3 from "../settings/NumberingSettings3";
import ReportAccountingDocDetails from "./ReportAccountingDocDetails";
import BTab from "../../tabs/BTab";
export default {
  name: 'Login',
  components: {
    BTab,
    BTabs,
    AccountingGroupsLists2,
    AccountingGroupsTree,
    NumberingSettings3,
    SaleMethods,
    Cashiers,
    Banks,
    ReportAccountingDocDetails
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

    }
  }, mounted() {

  }, watch: {

  },
  methods: {

  }
}

</script>
